import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import "./App.css";
import AnimatedNavbar from "./Components/Navbar";
import BlobBackground from "./Components/Blobs";
import AnimatedBackground from "./Components/Background";
import { Footer } from "./Components/Footer";
import PortfolioAIAgents from "./Pages/portfolio/AIAgents";
import { TwilioIVRs } from "./Pages/portfolio/TwilioIVRs";
import { WebApps } from "./Pages/portfolio/WebApps";
import { MobileApps } from "./Pages/portfolio/MobileApps";
import { A2PApproval } from "./Pages/portfolio/A2PApproval";
import ScrollToTop from "./Components/ScrollToTop";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService";
import { GHLIntegration } from "./Pages/portfolio/GHLIntegration";
import NotFound from "./Pages/NotFound";
import Seo from "./Components/Seo";

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <div className="relative min-h-screen  overflow-x-hidden text-white ">
        {/* <AnimatedBackground className="p-2" />
        <div className="absolute inset-0 -z-20 grid-overlay" /> */}
        {/* <BlobBackground /> */}

        {/* 🧭 Navbar & Page Content */}
        <div className="relative z-10">
          <AnimatedNavbar />
          <main className="">
            <Routes>
              {/* Each real page gets a canonical via <Seo />. The 404 route is left out on purpose. */}
              <Route path="/" element={<><Seo /><Home /></>} />
              <Route path="/about" element={<><Seo /><About /></>} />
              <Route path="/contact" element={<><Seo /><Contact /></>} />
              <Route path="/portfolio/ai-agents" element={<><Seo /><PortfolioAIAgents /></>} />
              <Route path="/portfolio/twilio-ivrs" element={<><Seo /><TwilioIVRs /></>} />
              <Route path="/portfolio/web-apps" element={<><Seo /><WebApps /></>} />
              <Route path="/portfolio/mobile-apps" element={<><Seo /><MobileApps /></>} />
              <Route path="/portfolio/a2p-approval" element={<><Seo /><A2PApproval /></>} />
              <Route path="/portfolio/ghl-integration" element={<><Seo /><GHLIntegration /></>} />
              <Route path="/privacy-policy" element={<><Seo /><PrivacyPolicy /></>} />
              <Route path="/terms-of-service" element={<><Seo /><TermsOfService /></>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />

        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
